var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "sip-view-page message-command-page" }, [
    _c("div", { staticClass: "nk-block-head nk-block-head-sm sip-view-head" }, [
      _c("div", { staticClass: "nk-block-between" }, [
        _c(
          "div",
          { staticClass: "nk-block-head-content admin-instance-page__intro" },
          [
            _c(
              "router-link",
              {
                staticClass:
                  "admin-instance-page__back admin-instance-page__back--pill",
                attrs: {
                  to: "/message/inbox",
                  title: _vm.trans("message.message"),
                  "aria-label": _vm.trans("message.message"),
                },
              },
              [
                _c("admin-icon", {
                  attrs: { name: "chevron-left", "aria-hidden": "true" },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _c("div", { staticClass: "admin-instance-page__intro-text" }, [
              _c("h3", { staticClass: "nk-block-title page-title mb-0" }, [
                _vm._v(
                  _vm._s(_vm.message.subject || _vm.trans("message.message"))
                ),
              ]),
              _vm._v(" "),
              _vm.message && _vm.message.user_from
                ? _c("div", { staticClass: "nk-block-des text-soft" }, [
                    _c("p", { staticClass: "mb-0" }, [
                      _vm._v(
                        _vm._s(_vm.message.user_from.email) +
                          " " +
                          _vm._s(_vm.trans("message.to")) +
                          " " +
                          _vm._s(_vm.message.user_to.email)
                      ),
                    ]),
                  ])
                : _vm._e(),
            ]),
          ],
          1
        ),
      ]),
    ]),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass:
          "card sip-view-card saas-message-layout message-command-layout",
      },
      [
        _c(
          "div",
          { staticClass: "row g-0" },
          [
            _c("message-sidebar", {
              attrs: { menu: "", statistics: _vm.statistics },
            }),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "col saas-message-main message-detail-main" },
              [
                _vm.message
                  ? _c("article", { staticClass: "sip-view-thread" }, [
                      _c("div", { staticClass: "sip-view-thread__meta" }, [
                        _c("img", {
                          staticClass: "message-avatar",
                          attrs: {
                            src: _vm.getAvatar(_vm.message.user_from),
                            alt: "",
                          },
                        }),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "sip-view-thread__meta-copy" },
                          [
                            _c("p", { staticClass: "sip-view-thread__route" }, [
                              _vm._v(
                                _vm._s(
                                  _vm.message.user_from.email +
                                    " " +
                                    _vm.trans("message.to") +
                                    " " +
                                    _vm.message.user_to.email
                                )
                              ),
                            ]),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "sip-view-thread__actions" },
                              [
                                _c(
                                  "button",
                                  {
                                    staticClass: "sip-view-icon-btn",
                                    attrs: {
                                      type: "button",
                                      "aria-label": _vm.isImportant(_vm.message)
                                        ? _vm.trans("message.important")
                                        : _vm.trans("message.mark_important"),
                                    },
                                    on: {
                                      click: function ($event) {
                                        return _vm.toggleImportant(_vm.message)
                                      },
                                    },
                                  },
                                  [
                                    _vm.isImportant(_vm.message)
                                      ? _c("i", {
                                          staticClass: "fas fa-star starred",
                                        })
                                      : _c("i", { staticClass: "far fa-star" }),
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "span",
                                  { staticClass: "sip-view-thread__time" },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm._f("momentDateTime")(
                                          _vm.message.created_at
                                        )
                                      )
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "button",
                                  {
                                    directives: [
                                      {
                                        name: "confirm",
                                        rawName: "v-confirm",
                                        value: {
                                          ok: _vm.confirmDelete(_vm.message),
                                        },
                                        expression:
                                          "{ok: confirmDelete(message)}",
                                      },
                                    ],
                                    key: _vm.message.id,
                                    staticClass:
                                      "btn btn-sm admin-toolbar-btn admin-toolbar-btn--outline",
                                    attrs: {
                                      type: "button",
                                      "aria-label": _vm.trans(
                                        "message.move_to_trash"
                                      ),
                                    },
                                  },
                                  [
                                    _c("i", {
                                      staticClass: "fas fa-trash",
                                      attrs: { "aria-hidden": "true" },
                                    }),
                                  ]
                                ),
                              ]
                            ),
                          ]
                        ),
                      ]),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "sip-view-thread__body",
                        domProps: { innerHTML: _vm._s(_vm.message.body) },
                      }),
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.message.has_attachment
                  ? _c("div", { staticClass: "message-attachments" }, [
                      _c(
                        "ul",
                        _vm._l(_vm.attachments, function (attachment) {
                          return _c("li", { key: attachment.uuid }, [
                            _c(
                              "a",
                              {
                                attrs: {
                                  href: `/message/${_vm.message.uuid}/attachment/${attachment.uuid}/download?token=${_vm.authToken}`,
                                },
                              },
                              [
                                _c("i", { staticClass: "fas fa-paperclip" }),
                                _vm._v(" " + _vm._s(attachment.user_filename)),
                              ]
                            ),
                          ])
                        }),
                        0
                      ),
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.replies && _vm.replies.length
                  ? _c(
                      "div",
                      { staticClass: "message-replies" },
                      _vm._l(_vm.replies, function (reply) {
                        return _c(
                          "article",
                          {
                            key: reply.id,
                            staticClass:
                              "sip-view-thread sip-view-thread--reply",
                          },
                          [
                            _c(
                              "div",
                              { staticClass: "sip-view-thread__meta" },
                              [
                                _c("img", {
                                  staticClass: "message-avatar",
                                  attrs: {
                                    src: _vm.getAvatar(reply.user_from),
                                    alt: "",
                                  },
                                }),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "sip-view-thread__meta-copy" },
                                  [
                                    reply
                                      ? _c(
                                          "p",
                                          {
                                            staticClass:
                                              "sip-view-thread__route",
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                reply.user_from.email +
                                                  " " +
                                                  _vm.trans("message.to") +
                                                  " " +
                                                  reply.user_to.email
                                              )
                                            ),
                                          ]
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      {
                                        staticClass: "sip-view-thread__actions",
                                      },
                                      [
                                        _c(
                                          "button",
                                          {
                                            staticClass: "sip-view-icon-btn",
                                            attrs: {
                                              type: "button",
                                              "aria-label": _vm.isImportant(
                                                reply
                                              )
                                                ? _vm.trans("message.important")
                                                : _vm.trans(
                                                    "message.mark_important"
                                                  ),
                                            },
                                            on: {
                                              click: function ($event) {
                                                return _vm.toggleImportant(
                                                  reply
                                                )
                                              },
                                            },
                                          },
                                          [
                                            _vm.isImportant(reply)
                                              ? _c("i", {
                                                  staticClass:
                                                    "fas fa-star starred",
                                                })
                                              : _c("i", {
                                                  staticClass: "far fa-star",
                                                }),
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "span",
                                          {
                                            staticClass:
                                              "sip-view-thread__time",
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm._f("momentDateTime")(
                                                  reply.created_at
                                                )
                                              )
                                            ),
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "button",
                                          {
                                            directives: [
                                              {
                                                name: "confirm",
                                                rawName: "v-confirm",
                                                value: {
                                                  ok: _vm.confirmDelete(reply),
                                                },
                                                expression:
                                                  "{ok: confirmDelete(reply)}",
                                              },
                                            ],
                                            key: reply.id,
                                            staticClass:
                                              "btn btn-sm admin-toolbar-btn admin-toolbar-btn--outline",
                                            attrs: {
                                              type: "button",
                                              "aria-label": _vm.trans(
                                                "message.move_to_trash"
                                              ),
                                            },
                                          },
                                          [
                                            _c("i", {
                                              staticClass: "fas fa-trash",
                                              attrs: { "aria-hidden": "true" },
                                            }),
                                          ]
                                        ),
                                      ]
                                    ),
                                  ]
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            _c("div", {
                              staticClass: "sip-view-thread__body",
                              domProps: { innerHTML: _vm._s(reply.body) },
                            }),
                            _vm._v(" "),
                            reply.has_attachment
                              ? _c("div", [
                                  _c(
                                    "ul",
                                    {
                                      staticClass: "message-attachments__list",
                                    },
                                    _vm._l(
                                      _vm.reply_attachments[reply.id],
                                      function (attachment) {
                                        return _c(
                                          "li",
                                          { key: attachment.uuid },
                                          [
                                            _c(
                                              "a",
                                              {
                                                attrs: {
                                                  href: `/message/${reply.uuid}/attachment/${attachment.uuid}/download?token=${_vm.authToken}`,
                                                },
                                              },
                                              [
                                                _c("i", {
                                                  staticClass:
                                                    "fas fa-paperclip",
                                                }),
                                                _vm._v(
                                                  " " +
                                                    _vm._s(
                                                      attachment.user_filename
                                                    )
                                                ),
                                              ]
                                            ),
                                          ]
                                        )
                                      }
                                    ),
                                    0
                                  ),
                                ])
                              : _vm._e(),
                          ]
                        )
                      }),
                      0
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c("h4", { staticClass: "sip-view-section-title" }, [
                  _vm._v(_vm._s(_vm.trans("message.reply"))),
                ]),
                _vm._v(" "),
                _c(
                  "form",
                  {
                    on: {
                      submit: function ($event) {
                        $event.preventDefault()
                        return _vm.submit.apply(null, arguments)
                      },
                      keydown: function ($event) {
                        return _vm.replyForm.errors.clear($event.target.name)
                      },
                    },
                  },
                  [
                    _c(
                      "div",
                      { staticClass: "form-group" },
                      [
                        _c("html-editor", {
                          attrs: {
                            name: "body",
                            model: _vm.replyForm.body,
                            isUpdate: false,
                          },
                          on: {
                            "update:model": function ($event) {
                              return _vm.$set(_vm.replyForm, "body", $event)
                            },
                            clearErrors: function ($event) {
                              return _vm.replyForm.errors.clear("body")
                            },
                          },
                        }),
                        _vm._v(" "),
                        _c("show-error", {
                          attrs: {
                            "form-name": _vm.replyForm,
                            "prop-name": "body",
                          },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "form-group" },
                      [
                        _c("file-upload-input", {
                          attrs: {
                            "button-text": _vm.trans("message.attachment"),
                            token: _vm.replyForm.upload_token,
                            module: "message",
                            "clear-file": _vm.clear_message_attachment,
                            "module-id": "",
                          },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "saas-form-actions text-right" }, [
                      _c(
                        "button",
                        {
                          staticClass:
                            "btn btn-sm admin-toolbar-btn admin-toolbar-btn--solid",
                          attrs: { type: "submit" },
                        },
                        [
                          _c("i", { staticClass: "fas fa-paper-plane" }),
                          _vm._v(" " + _vm._s(_vm.trans("message.send"))),
                        ]
                      ),
                    ]),
                  ]
                ),
              ]
            ),
          ],
          1
        ),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }